import { Component, OnInit, EventEmitter, Output, Input } from '@angular/core';
import { HttpClient, HttpEventType } from '@angular/common/http';


@Component({
  selector: 'app-upload',
  templateUrl: './upload.component.html',
  styleUrls: ['./upload.component.css']
})
export class UploadComponent implements OnInit {

  public progress: number;
  public message: string;
  public width1: number;
  public height1: number;
  public sonuc: string;
  public type: string = 'upload';
  @Input() public yuklemeTipi: string;

  @Output() public onUploadFinished = new EventEmitter();

  constructor(private http: HttpClient) { }
  ngOnInit() {
  }

  public uploadFile = (files) => {
    if (files.length === 0) {
      return;
    }

    let fileToUpload = <File>files[0];
    const formData = new FormData();
    formData.append('file', fileToUpload, fileToUpload.name);

    console.log(fileToUpload.size);

    if (this.yuklemeTipi == 'Foto') {
      this.validateIsFileImage(fileToUpload.name);
      // resim dimension,size,extension check..
      const URL = window.URL || window.webkitURL;
      const Img = new Image();

      Img.src = URL.createObjectURL(fileToUpload);
      let height = 0;
      let width = 0;
      Img.onload = (e: any) => {
        if (e.path != undefined) {
          height = e.path[0].height;
          width = e.path[0].width;
        }
        else {
          height = 667;
          width = 1000;
        }

        console.log(height, width);
        console.log(height, width);
        if (width == 1000 && height == 667) {
          console.log('flag 1');
          this.sendImageDataToServer(fileToUpload, formData);
        }
        else {
          console.log('flag 2');
          this.message = 'Görsel boyutları 1000 px * 667 px olmalıdır.';
          this.type = 'upload-error';
        }
      }
    }
    else if (this.yuklemeTipi == 'Video') {
      this.sendVideoDataToServer(fileToUpload, formData);
    }
  }

  sendImageDataToServer(fileToUpload: File, formData: FormData) {
    //https://api-heykel.milliyetsanat.com
    //'<https://api-heykel.milliyetsanat.com>/api/upload'
    console.log(this.yuklemeTipi);
    // yüklenen dosya görsel ise..
    if (this.yuklemeTipi == 'Foto') {
      if (this.validateIsFileImage(fileToUpload.name) && this.validateFileImageSize(fileToUpload.size)) {
        console.log('asd');
        this.http.post('https://api-heykel.milliyetsanat.com/api/upload', formData, { reportProgress: true, observe: 'events' })
          .subscribe(event => {
            if (event.type === HttpEventType.UploadProgress)
              this.progress = Math.round(100 * event.loaded / event.total);
            else if (event.type === HttpEventType.Response) {
              this.message = 'Yükleme başarılı.';
              this.type = 'upload';
              this.onUploadFinished.emit(event.body);
            }
          });
          console.log(fileToUpload.name);
      }
      else {
        this.message = "Görsel 1000 px * 667 px ölçüsünde .png, .jpg, .jpeg formatında ve 10 MB'den küçük olmalıdır.";
        this.type = 'upload-error';
      }
    }
    else if (this.yuklemeTipi == 'Video') {
      if (this.validateIsFileVideo(fileToUpload.name) && this.validateFileVideoSize(fileToUpload.size)) {
        this.http.post('https://api-heykel.milliyetsanat.com/api/upload', formData, { reportProgress: true, observe: 'events' })
          .subscribe(event => {
            this.message = '';
            if (event.type === HttpEventType.UploadProgress)
              this.progress = Math.round(100 * event.loaded / event.total);
            else if (event.type === HttpEventType.Response) {
              this.message = 'Yükleme başarılı.';
              this.type = 'upload';
              this.onUploadFinished.emit(event.body);
            }
          });
      } else {
        this.message = "Video formatı .mp4 ve 50 MB'den küçük olmalıdır.";
        this.type = 'upload-error';
      }
    }
  }

  sendVideoDataToServer(fileToUpload: File, formData: FormData) {
    //https://api-heykel.milliyetsanat.com
    //'https://api-heykel.milliyetsanat.com/api/upload'
    console.log(this.yuklemeTipi);
    // yüklenen dosya görsel ise.. 
    if (this.validateIsFileVideo(fileToUpload.name) && this.validateFileVideoSize(fileToUpload.size)) {
      this.http.post('https://api-heykel.milliyetsanat.com/api/upload', formData, { reportProgress: true, observe: 'events' })
        .subscribe(event => {
          if (event.type === HttpEventType.UploadProgress)
            this.progress = Math.round(100 * event.loaded / event.total);
          else if (event.type === HttpEventType.Response) {
            this.message = 'Yükleme başarılı.';
            this.type = 'upload';
            this.onUploadFinished.emit(event.body);
          }
        });
    } else {
      this.message = "Video formatı .mp4 ve 50 MB'den küçük olmalıdır.";
      this.type = 'upload-error';
    }
  }
  validateFileImageSize(size: number) {
    if (size <= 10000000) {
      console.log('boyut kontrolü başarılı');
      return true;
    }
    else {
      this.message = "Görsel 1000 px * 667 px ölçüsünde .png, .jpg, .jpeg formatında ve 10 MB'den küçük olmalıdır.";
      this.type = 'upload-error';
      return false;
    }
  }

  validateIsFileImage(name: String) {
    var ext = name.substring(name.lastIndexOf('.') + 1);
    if (ext.toLowerCase() == 'png' || ext.toLowerCase() == 'jpg' || ext.toLowerCase() == 'jpeg') {
      console.log('görsel');
      return true;
    }
    else {
      this.message = "Görsel 1000 px * 667 px ölçüsünde .png, .jpg, .jpeg formatında ve 10 MB'den küçük olmalıdır.";
      this.type = 'upload-error';
      console.log('görsel değil');
      return false;
    }
  }


  // 50MB
  validateFileVideoSize(size: number) {
    if (size <= 50000000) {
      console.log('boyut kontrolü başarılı');
      return true;
    }
    else {
      this.message = 'boyut 50MB fazla olmamalıdır.';
      this.type = 'upload-error';
      return false;
    }
  }

  validateIsFileVideo(name: String) {
    var ext = name.substring(name.lastIndexOf('.') + 1);
    if (ext.toLowerCase() == 'mp4') {
      console.log('video');
      return true;
    }
    else {
      this.message = 'Yükleme başarılı değil'
      this.type = 'upload-error';
      console.log('video değil');
      return false;
    }
  }
  AddFilesToFormData(file: File) {
    debugger;
    console.log('*');
    let result: string = '-';
    const reader = new FileReader();
    reader.readAsDataURL(file);
    reader.onload = () => {
      const img = new Image();
      img.src = reader.result as string;
      img.onload = () => {
        const height = img.naturalHeight;
        const width = img.naturalWidth;
        console.log('Width and Height', width, height);
        if (width == 1000 && height == 667) {
          this.width1 = width;
          this.height1 = height;
          result = '1000-667';
        }
        else {
          this.message = "Görsel 1000 px * 667 px ölçüsünde .png, .jpg, .jpeg formatında ve 10 MB'den küçük olmalıdır.";
          this.type = 'upload-error';
          result = 'not-OK';
        }
      };
    }
    return result;
  }
}
